export default "__VITE_ASSET__DwKPhj1q__"